import React, {useEffect, useState} from 'react'
import classes from './Job.module.css'
import {Link, useParams, useHistory} from 'react-router-dom'
import {FiBriefcase, FiClock} from 'react-icons/fi'
import {Button} from '../../components/Button/Button'
import {EmployeeLayout} from "../../Authenticated/Employee/EmployeeLayout/EmployeeLayout";
import {authAxios} from "../../API/apiRequest";
import TimeAgo from "javascript-time-ago";
import {Modal} from "react-bootstrap"
import style from "../../Authenticated/Employee/Submissions/Submissions.module.css";
import {ToastContainer, toast} from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import {Loading} from "../../components/Loading/Loading";

interface Props {
}

export const Job: React.FC<Props> = () => {
    const timeAgo = new TimeAgo('ar-EG')
    let Params: any = useParams()
    let history = useHistory();
    const [saved, setsaved] = useState<boolean>(false)
    const [Load, setLoad] = useState<boolean>(true);
    const [answer, setanswer] = useState<Array<string>>([]);
    const [QAshow, setQAshow] = useState<boolean>(false)
    const [cansubmit, setcansubmit] = useState<boolean>(true)
    const [JopData, setJopData] = useState<{
        id: string; isSaved: boolean, advantages: Array<string>, age: string,
        companyId: string,
        canApply: boolean,
        companyImage: string,
        companyName: string,
        createdAt: string,
        description: string,
        edu: string,
        employeeNumber: number,
        exp: string,
        field: string,
        gender: string,
        requireCV: boolean,
        hasApplication: boolean,
        requirements: Array<string>,
        questions: Array<string>,
        salary: string,
        specialty: string,
        title: string,
        type: string,
    }>();
    const HandleSaveJop = (id: string, onlysave?: boolean) => {
        if(onlysave) {
            if(!saved) {
                authAxios.post(`/employee/saved/${id}`).then((res) => {
                    if(res.status === 201) {
                        setsaved(true);
                        toast.success("تم حفظ الوظيفة");
                    }
                })
            } else {
                toast.info("تم حفظ الوظيفة من قبل");
            }
        } else if(!saved) {
            authAxios.post(`/employee/saved/${id}`).then((res) => {
                if(res.status === 201) {
                    setsaved(true);
                    toast.success("تم حفظ الوظيفة");
                }
            })
        } else {
            authAxios.delete(`/employee/saved/${id}`).then((res) => {
                if(res.status === 200) {
                    setsaved(false);
                    toast.error("تم حذف الوظيفة من المحفوظات");
                }
            })
        }
    }
    const handleSubmit = () => {
        if(JopData) {
            if(JopData.questions.length > 0) {
                setQAshow(true)
            } else {
                handleSubmitjob()
            }
        }
    }
    const handleSubmitjob = () => {
        setQAshow(false);
        if(JopData && JopData.questions.length === answer.length) {
            if(answer.length > 0) {
                authAxios.post(`/jobs/apply/${JopData.id}`, {answers: answer}).then((res) => {
                    if(res.data === "Created") {
                        let data = {...JopData};
                        data.hasApplication = true;
                        setJopData(data);
                        toast.success("تم التقديم علي الوظيفة بنجاح");
                    }
                }).catch(err => {
                    handleerror(err)
                })
            } else {
                authAxios.post(`/jobs/apply/${JopData.id}`).then((res) => {
                    if(res.data === "Created") {
                        let data = {...JopData};
                        data.hasApplication = true;
                        setJopData(data);
                        toast.success("تم التقديم علي الوظيفة بنجاح");
                    }
                }).catch(err => {
                    handleerror(err)
                })
            }
        }
    }
    const handleerror = (err: any) => {
        toast.error(() => <div>
            {err.response.data.errors.map((er: string, index: number) => {
                return (<div key={index}>
                    {er === "هذه الوظيفة تطلب ملف شخصي من فضلك قم بإضافة الملف الشخصي اولاً" ? (
                            <>
                                <p className={classes.errnoti}>{er}</p>
                                <div className={'px-2'}>
                                    <ol className={classes.listyle}>
                                        <li>احفظ الوظيفه <span className={classes.linksave} onClick={() => {
                                            HandleSaveJop(JopData ? JopData.id : "", true)
                                        }}>من هنا</span></li>
                                        <li>اختر السيرة الذاتية واضف الملف الشخصي <span className={classes.linksave}
                                                                                        onClick={() => {
                                                                                            history.push("/employee/profile")
                                                                                        }}>من هنا</span></li>
                                        <li>قم بالتقديم مرة اخري</li>

                                    </ol>
                                </div>

                            </>
                    ) : (
                            <p className={classes.errnoti}>{er}</p>
                    )}

                </div>)
            })}

        </div>, {autoClose: 10000});
    }
    useEffect(() => {
        setLoad(true)
        window.scrollTo(0, 0)
        authAxios.get(`/jobs/${Params.id}`).then((res) => {
            if(res.status === 200) {
                setJopData(res.data.job);
                setsaved(res.data.job.isSaved);
                setLoad(false)
            }
        }).catch(e=>{
            return history.replace('/404')
        })
    }, [Params.id, history]);
    return (
            <React.Fragment>

                <EmployeeLayout>
                    {!Load && JopData ? (
                            <div className={"animate__animated animate__fadeIn  " + classes.container}>
                                <ToastContainer
                                        closeOnClick={false}
                                        autoClose={3000}
                                        pauseOnHover
                                        newestOnTop
                                        hideProgressBar={false}

                                        position="bottom-right" rtl/>
                                <div className={classes.all}>
                                    <div className={classes.secondJobSection}>
                                        <div className={classes.headSecond}>
                                            <p>تفاصيل الوظيفة</p>
                                        </div>
                                        <div dir="rtl" style={{color: '#fff'}} className={classes.description}>
                                            {JopData.description}
                                        </div>
                                        {JopData.requirements.length > 0 ? (
                                                <>
                                                    <div className={classes.headSecond}>
                                                        <p>المتطلبات</p>
                                                    </div>
                                                    <div dir="rtl">
                                                        <ul style={{color: 'white'}}>
                                                            {JopData.requirements.map((req, index) => {
                                                                return (
                                                                        <li key={index}>{req}</li>
                                                                );
                                                            })}


                                                        </ul>
                                                    </div>
                                                </>
                                        ) : ""}

                                        {JopData.advantages.length > 0 ? (<>
                                            <div className={classes.headSecond}>
                                                <p>المميزات</p>
                                            </div>
                                            <div dir="rtl">
                                                <ul style={{color: 'white'}}>
                                                    {JopData.advantages.map((adv, index) => {
                                                        return (
                                                                <li key={index}>{adv}</li>
                                                        );
                                                    })}


                                                </ul>
                                            </div>
                                        </>) : ""}
                                    </div>

                                    <div className={classes.info}>
                                        <Link to={`/company/${JopData.companyId}`}
                                              className={"my-2 " + classes.company}>
                                            <div className={classes.companyName}>
                                                <p>{JopData.companyName}</p>
                                            </div>
                                            <img src={JopData.companyImage}
                                                 onError={({currentTarget}) => {
                                                     currentTarget.onerror = null; // prevents looping
                                                     currentTarget.src = "../../assets/icons/NoCompany.svg";
                                                 }}
                                                 className={classes.image} alt={JopData.companyName}/>
                                        </Link>
                                        {/*<div className={classes.statics}>*/}
                                        {/*    <div className={classes.staticElement}>*/}
                                        {/*       <p>طلب مرفوض</p> */}
                                        {/*       <p>{number}</p>*/}
                                        {/*       <FiXSquare color='#BBBBBB' size={30}/>*/}
                                        {/*    </div>*/}
                                        {/*    <div className={classes.staticElement}>*/}
                                        {/*       <p>طلب مقدم</p>*/}
                                        {/*        <p>{number}</p>*/}
                                        {/*       <FiFileText color='#BBBBBB' size={30}/>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        <div className={classes.firstJobSection}>
                                            <div className={classes.head}>
                                                <div onClick={() => HandleSaveJop(JopData.id)}
                                                     className={classes.IconSave}>
                                                    {saved ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1"

                                                                 width="25" height="25" x="0" y="0"
                                                                 viewBox="0 0 512 512"
                                                                 className="">
                                                                <g>
                                                                    <g xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="m400.6 0h-289.2c-25.487 0-47.133 20.556-47.133 47.133v427.63c0 20.532 16.712 37.236 37.253 37.236 10.34 0 20.088-4.032 27.448-11.354l110.235-110.204c4.423-4.447 10.53-6.975 16.797-6.975s12.374 2.528 16.797 6.975l110.235 110.204c7.36 7.322 17.108 11.354 27.448 11.354 20.541 0 37.253-16.704 37.253-37.236v-427.63c0-26.577-21.646-47.133-47.133-47.133z"
                                                                              fill="#ff6b61" data-original="#ff6b61"
                                                                              className=""></path>
                                                                        <path
                                                                                d="m400.6 0h-144.6v383.467c6.267 0 12.374 2.528 16.797 6.975l110.235 110.204c7.36 7.322 17.108 11.354 27.448 11.354 20.541 0 37.253-16.704 37.253-37.236v-427.631c0-26.577-21.646-47.133-47.133-47.133z"
                                                                                fill="#ee3368" data-original="#ee3368"
                                                                                className=""></path>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                    ) : (
                                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1"

                                                                 width="25" height="25" x="0" y="0"
                                                                 viewBox="0 0 511.958 511.958"
                                                                 className="">
                                                                <g>
                                                                    <path xmlns="http://www.w3.org/2000/svg"
                                                                          d="m400.579 0h-289.2c-25.487 0-47.133 20.556-47.133 47.133v427.63c.075 33.733 41.277 49.561 64.701 25.882l110.235-110.204c8.834-9.216 24.76-9.216 33.594 0l110.235 110.204c23.434 23.688 64.631 7.836 64.701-25.882v-427.63c0-26.577-21.646-47.133-47.133-47.133zm17.133 474.764c-.037 7.142-8.915 9.499-13.508 4.649-22.037-22.071-84.882-84.897-110.195-110.164-19.913-20.826-56.117-20.832-76.021-.04-17.486 17.453-51.714 51.671-78.696 78.645l-31.39 31.376c-4.523 4.799-13.512 3.197-13.657-4.194v-427.903c0-9.582 7.767-17.133 17.134-17.133h289.199c9.353 0 17.134 7.539 17.134 17.133z"
                                                                          data-original="#000000" fill="white"
                                                                          className=""></path>
                                                                </g>
                                                            </svg>
                                                    )} </div>
                                                <div className={classes.title}>
                                                    <p>{JopData.title}</p>
                                                </div>
                                                <FiBriefcase className={classes.headIcon} size={40} color='#BBBBBB'/>
                                            </div>
                                            <div className={classes.item}>
                                                <p> {(timeAgo.format(Date.now() - (Date.now() - new Date(JopData.createdAt).getTime()))).toString()}</p>
                                                <FiClock size={22} color='#BBBBBB'/>
                                            </div>
                                            <div className={classes.item}>
                                                <p style={{marginTop: 15}}>{JopData.employeeNumber}</p>
                                                <p style={{...styleText, marginTop: 15}}>:عدد العمالة</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.exp}</p>
                                                <p style={styleText}>:الخبرة</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.edu}</p>
                                                <p style={styleText}>:التعليم</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.age} - {JopData.gender} </p>
                                                <p style={styleText}>:السن والنوع</p>
                                            </div>
                                            <div className={classes.item}>
                                                {/*<p style={{marginRight: 5}}>جينه / شهرياً</p>*/}
                                                <p>{JopData.salary}</p>
                                                <p style={styleText}>:الراتب</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.type}</p>
                                                <p style={styleText}>:وقت العمل</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!JopData.canApply && JopData.hasApplication ? (
                                        <div className={'d-flex justify-content-center '}>
                                            <p className={classes.TextNote}>تم ارسال طلب التقديم</p>
                                        </div>) : JopData.canApply && !JopData.hasApplication ? (
                                        <div style={{alignSelf: 'center', marginTop: "10px"}}>
                                            <Button
                                                    onPress={() => handleSubmit()}
                                                    width={250}
                                                    fontSize={17}
                                                    height={60}
                                                    color='#6EB66C'>التقديم علي الوظيفة</Button>
                                        </div>
                                ) : ""}

                            </div>
                    ) : <Loading/>}


                    <Modal
                            show={QAshow}
                            onHide={() => {
                                setQAshow(false);
                                setcansubmit(true);
                                setanswer([]);
                            }}
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                    >
                        <Modal.Header>
                            <div className={'rtl w-100 d-flex justify-content-between'}>

                                <p className={"p-0 m-0 " + style.ModalTitle}>استمارة التقديم</p>


                                <button className={'btn ' + style.btnClose} onClick={() => {
                                    setQAshow(false)
                                    setcansubmit(true);
                                    setanswer([]);
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" x="0" y="0"
                                         viewBox="0 0 365.71733 365">
                                        <g>
                                            <g xmlns="http://www.w3.org/2000/svg" fill="#f44336">
                                                <path
                                                        d="m356.339844 296.347656-286.613282-286.613281c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503906-12.5 32.769532 0 45.25l286.613281 286.613282c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082032c12.523438-12.480468 12.523438-32.75.019532-45.25zm0 0"
                                                        fill="#f44336" data-original="#f44336" className=""></path>
                                                <path
                                                        d="m295.988281 9.734375-286.613281 286.613281c-12.5 12.5-12.5 32.769532 0 45.25l15.082031 15.082032c12.503907 12.5 32.769531 12.5 45.25 0l286.632813-286.59375c12.503906-12.5 12.503906-32.765626 0-45.246094l-15.082032-15.082032c-12.5-12.523437-32.765624-12.523437-45.269531-.023437zm0 0"
                                                        fill="#f44336" data-original="#f44336" className=""></path>
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>

                        </Modal.Header>
                        <Modal.Body>
                            <div className={" rtl "}>
                                {JopData && JopData.questions.map((Qa, index) => {
                                    return (
                                    <div key={index} className={"my-3"}>
                                        <label htmlFor={Qa}>{Qa}</label>
                                        <input style={{boxSizing: 'border-box'}} id={Qa} placeholder={Qa} onChange={e => {
                                            var ans = answer;
                                            ans[index] = e.target.value;
                                            if(ans.length === JopData.questions.length && ans.every(an => an !== '')) {
                                                setcansubmit(false);
                                            } else {
                                                setcansubmit(true);
                                            }
                                            setanswer(ans);
                                        }} type="text" className={`form-control ` + classes.inputstyle}/>
                                    </div>)
                                })}
                            </div>

                        </Modal.Body>

                        <div className={"d-flex justify-content-center pb-3"}>

                            <Button
                                    onPress={() => handleSubmitjob()}
                                    width={250}
                                    fontSize={17}
                                    height={60}
                                    disabled={cansubmit}
                                    color='#6EB66C'>قدم الطلب</Button>

                        </div>

                    </Modal>


                </EmployeeLayout>
            </React.Fragment>
    )
}
const styleText = {
    color: '#BBBBBB',
    margin: 0,
    padding: 0
}